/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from "@material-ui/core";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsRadioButton from "app/common/form/GlobitsRadioButton";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import {
  PAYMENT_METHOD_CHARACTERISTIC_CASH_CODE,
  PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
} from "app/common/LocalConst";
import { calcPaymentRemainder, roundVnd } from "app/common/LocalFunction";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect } from "react";
import SelectCardFeePopup from "../Popup/SelectCardFeePopup";
import SelectDepositMoneyFeePopup from "../Popup/SelectDepositMoneyFeePopup";
// import SelectCardFeePopup from "../Popup/SelectCardFeePopup";
function TotalOfVoucherByDeposit({
  nameSpace,
  disabled,
  moneyAfterDiscount,
  listPaymentMethod,
  listStk,
  listPos,
  listHomecredit,
  listPos_tragop,
  patientId,
}) {
  const { values, setFieldValue } = useFormikContext();

  const withNameSpace = (name, index) => {
    return `${nameSpace}[${index}].${name}`;
  };

  useEffect(() => {
    let sum =
      (values?.voucherPaymentMethods || []).reduce((acc, el) => {
        if (
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
        ) {
          return acc;
        }
        return acc + roundVnd(el?.totalOfMethod);
      }, 0);

    let voucherPaymentMethods = (values?.voucherPaymentMethods || []).map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        return {
          ...el,
          totalOfMethod: calcPaymentRemainder(moneyAfterDiscount, sum),
          bankName: el?.paymentBank?.propertyName,
          bankAccountNumber: el?.paymentBank?.property,
        };
      }
      return el;
    });

    setFieldValue("voucherPaymentMethods", voucherPaymentMethods);
  }, [moneyAfterDiscount]);

  const handleChangeTotalOfMethod = (e, item, index) => {
    let value = roundVnd(e?.target?.value);
    if (value < 0) value = 0;

    const otherSum = (values?.voucherPaymentMethods || []).reduce((acc, el, ind) => {
      if (ind === index || el?.paymentMethodValue?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT) {
        return acc;
      }
      return acc + roundVnd(el?.totalOfMethod);
    }, 0);

    if (value > roundVnd(moneyAfterDiscount) - otherSum) {
      value = Math.max(0, calcPaymentRemainder(moneyAfterDiscount, otherSum));
    }

    //set value
    setFieldValue(withNameSpace("totalOfMethod", index), value);

    let newVoucherPaymentMethods =
      values?.voucherPaymentMethods?.length > 0 &&
      values?.voucherPaymentMethods?.map((el, ind) => {
        if (index === ind) return { ...el, totalOfMethod: value };
        else return el;
      });

    let sum =
      newVoucherPaymentMethods?.length > 0 &&
      newVoucherPaymentMethods?.reduce((acc, el) => {
        if (
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
        ) {
          return acc;
        }
        return acc + +el?.totalOfMethod;
      }, 0);
    //if method bank then set stk account bank
    if (
      item?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listStk?.[0]);
    }

    if (item?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS) {
      setFieldValue(withNameSpace("paymentBank", index), listPos?.[0]);
    }

    if (item?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT) {
      setFieldValue(withNameSpace("paymentBank", index), listHomecredit?.[0]);
    }
    if (
      item?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listPos_tragop?.[0]);
    }
    //if methodnot bank :re calculate totalOfMethod

    values?.voucherPaymentMethods?.forEach((el, index) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        let amountBank = calcPaymentRemainder(moneyAfterDiscount, sum);
        setFieldValue(withNameSpace("totalOfMethod", index), amountBank);
      }
    });
  };

  return (
    <div
      style={{ overflow: "auto", scrollbarWidth: "thin", padding: "0" }}
      className="table-root table-concept-datatype"
    >
      <div style={{ maxHeight: "60vh", padding: "0" }}>
        <table className="table-container table-layout-fixed">
          <thead className="row-table-header">
            <tr>
              <th width="60%" style={{ color: "#4276a4" }}>
                HTTT
              </th>
              <th width="40%" style={{ color: "#4276a4" }}>
                Số tiền
              </th>
              {/* <th style={{ color: "#4276a4" }}>Ghi chú</th> */}
            </tr>
          </thead>
          <tbody>
            {listPaymentMethod?.length > 0 &&
              listPaymentMethod?.map((el, index) => {
                if (
                  el?.isUsing &&
                  (el?.code === PAYMENT_METHOD_CHARACTERISTIC_CASH_CODE ||
                    el?.characteristic ===
                      PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
                    el?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS)
                ) {
                  return (
                    <>
                      <tr key={index}>
                        <td>
                          <div className="flex align-center">
                            <GlobitsRadioButton
                              name={"totalRadio"}
                              value={el + 1}
                              type="radio"
                              checked={values?.totalRadio === index + 1}
                              onChange={(e) => {
                                // nếu là dùng thẻ thì ko xử lí
                                if (
                                  el?.characteristic ===
                                  PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
                                ) {
                                  return;
                                }
                                setFieldValue("totalRadio", index + 1);
                                let voucherPaymentMethods =
                                  values?.voucherPaymentMethods?.map(
                                    (el, stt) => {
                                      if (stt === index) {
                                        return {
                                          ...el,
                                          totalOfMethod: moneyAfterDiscount,
                                        };
                                      } else {
                                        return {
                                          ...el,
                                          totalOfMethod: 0,
                                        };
                                      }
                                    }
                                  );
                                setFieldValue(
                                  "voucherPaymentMethods",
                                  voucherPaymentMethods
                                );

                                if (
                                  el?.characteristic ==
                                  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                                ) {
                                  setFieldValue(
                                    withNameSpace("paymentBank", index),
                                    listStk?.[0]
                                  );
                                }
                                if (
                                  el?.characteristic ==
                                  PAYMENT_METHOD_CHARACTERISTIC_POS
                                ) {
                                  setFieldValue(
                                    withNameSpace("paymentBank", index),
                                    listPos?.[0]
                                  );
                                  setFieldValue(
                                    withNameSpace("bankName", index),
                                    listPos?.[0]?.propertyName
                                  );
                                  setFieldValue(
                                    withNameSpace("bankAccountNumber", index),
                                    listPos?.[0]?.property
                                  );
                                }

                                if (
                                  el?.characteristic ===
                                  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
                                ) {
                                  setFieldValue(
                                    withNameSpace("paymentBank", index),
                                    listHomecredit?.[0]
                                  );
                                  setFieldValue(
                                    withNameSpace("bankName", index),
                                    listHomecredit?.[0]?.propertyName
                                  );
                                  setFieldValue(
                                    withNameSpace("bankAccountNumber", index),
                                    listHomecredit?.[0]?.property
                                  );
                                }

                                if (
                                  el?.characteristic ===
                                  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
                                ) {
                                  setFieldValue(
                                    withNameSpace("paymentBank", index),
                                    listPos_tragop?.[0]
                                  );

                                  setFieldValue(
                                    withNameSpace("bankName", index),
                                    listPos_tragop?.[0]?.propertyName
                                  );
                                  setFieldValue(
                                    withNameSpace("bankAccountNumber", index),
                                    listPos_tragop?.[0]?.property
                                  );
                                }
                              }}
                            />
                            {el?.name}
                            {el?.characteristic === // the
                              PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD && (
                              <IconCardSelect
                                patientId={patientId}
                                values={values}
                              />
                            )}
                            {el?.characteristic === //tien cọc
                              PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT && (
                              <IconDepositSelect
                                patientId={patientId}
                                values={values}
                              />
                            )}
                          </div>
                        </td>

                        <td>
                          <GlobitsVNDCurrencyInput
                            name={withNameSpace("totalOfMethod", index)}
                            disabled={
                              disabled ||
                              el?.characteristic ===
                                PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
                              el?.characteristic ===
                                PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
                              el?.characteristic ===
                                PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                            }
                            onChange={(e) =>
                              handleChangeTotalOfMethod(e, el, index)
                            }
                            // notDelay
                          />
                        </td>
                        {/* <td>
                          <GlobitsTextField
                            name={withNameSpace("note", index)}
                            disabled={disabled}
                          />
                        </td> */}
                      </tr>

                      {el?.characteristic ===
                        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
                        getIn(values, withNameSpace("totalOfMethod", index)) !=
                          0 && (
                          <tr>
                            <td colSpan={2}>
                              <GlobitsPagingAutocomplete
                                disabled={disabled}
                                placeholder="Chọn stk"
                                name={withNameSpace("paymentBank", index)}
                                api={pagingExtGlobalProperty}
                                searchObject={{
                                  isActive: true,
                                  dataType: TYPE_GLOBAL_PROPOTIES_BANK,
                                  departmentIds: values?.department
                                    ? [values?.department.id]
                                    : [],
                                }}
                                getOptionLabel={(option) => {
                                  return `${option?.propertyName} - ${option?.property}`;
                                }}
                                onChange={(_, value) => {
                                  setFieldValue(
                                    withNameSpace("paymentBank", index),
                                    value
                                  );
                                  setFieldValue(
                                    withNameSpace("bankAccountNumber", index),
                                    value?.property
                                  );
                                  setFieldValue(
                                    withNameSpace("bankName", index),
                                    value?.propertyName
                                  );
                                }}
                              />
                            </td>
                          </tr>
                        )}

                      {el?.characteristic ===
                        PAYMENT_METHOD_CHARACTERISTIC_POS &&
                        getIn(values, withNameSpace("totalOfMethod", index)) !=
                          0 && (
                          <tr>
                            <td colSpan={2}>
                              <GlobitsPagingAutocomplete
                                disabled={disabled}
                                placeholder="Chọn máy pos"
                                name={withNameSpace("paymentBank", index)}
                                api={pagingExtGlobalProperty}
                                searchObject={{
                                  isActive: true,
                                  dataType: TYPE_GLOBAL_PROPOTIES_POS_LIST,
                                  departmentIds: values?.department
                                    ? [values?.department.id]
                                    : [],
                                }}
                                getOptionLabel={(option) => {
                                  return `${option?.propertyName} - ${option?.property}`;
                                }}
                                onChange={(_, value) => {
                                  setFieldValue(
                                    withNameSpace("paymentBank", index),
                                    value
                                  );
                                  setFieldValue(
                                    withNameSpace("bankAccountNumber", index),
                                    value?.property
                                  );
                                  setFieldValue(
                                    withNameSpace("bankName", index),
                                    value?.propertyName
                                  );
                                }}
                              />
                            </td>
                          </tr>
                        )}
                    </>
                  );
                }
                return <></>;
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const IconCardSelect = observer(({ patientId, values }) => {
  const { handleOpenClientCardFeePopup, openClientCardFeePopup } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn thẻ">
        <div
          onClick={() => {
            handleOpenClientCardFeePopup({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openClientCardFeePopup && <SelectCardFeePopup />}
    </div>
  );
});

const IconDepositSelect = observer(({ patientId, values }) => {
  const { handleOpenDepositMoneyFeePopup, openDepositMoneyFeePopup } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn tièn cọc">
        <div
          onClick={() => {
            handleOpenDepositMoneyFeePopup({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openDepositMoneyFeePopup && <SelectDepositMoneyFeePopup />}
    </div>
  );
});
export default memo(observer(TotalOfVoucherByDeposit));
